import { useContext, useCallback } from 'react'
import { AuthContext } from '../context/Auth/AuthContext'

const permissionRoutes = {
  ver_dashboard: '/',
  ver_relatorios: '/relatorios',
  ver_atendimentos: '/tickets',
  ver_respostas_rapidas: '/quick-messages',
  ver_kanban: '/kanban',
  ver_crm: '/crm',
  ver_dashboard_crm: '/crm/conversions',
  ver_tarefas: '/todolist',
  ver_contatos: '/contacts',
  ver_agendamentos: '/schedules',
  ver_agenda: '/agenda',
  ver_agenda_propria: '/agenda',
  ver_tags: '/tags',
  ver_chat_interno: '/chats',
  ver_ajuda: '/helps',
  ver_listagem: '/campaigns',
  ver_listas_contatos: '/contact-lists',
  ver_configuracoes_campanhas: '/campaigns-config',
  ver_conexoes: '/connections',
  ver_lista_arquivos: '/files',
  ver_filas_chatbot: '/queues',
  manage_roles: '/roles',
  ver_usuarios: '/users',
  ver_api: '/messages-api',
  ver_financeiro: '/financeiro',
  ver_configuracoes: '/settings',
  ver_openai: '/prompts',
  ver_integracoes: '/queue-integration',
  gerencia_grupos: '/group-participants',
}

const usePermission = () => {
  const { user } = useContext(AuthContext)

  const hasPermission = useCallback(
    permission => {
      if (!permission) return true
      if (user?.super) return true
      return permission.split('|').some(item => (user?.permissions || []).includes(item))
    },
    [user]
  )

  const isAdmin = Boolean(user?.super || user?.profile === 'admin')

  const firstPermissionRoute = useCallback(() => {
    const permissions = user?.permissions || []
    for (const permission of permissions) {
      if (permissionRoutes[permission]) {
        return permissionRoutes[permission]
      }
    }
    return '/'
  }, [user])

  return { hasPermission, isAdmin, firstPermissionRoute }
}

export default usePermission
